import React from 'react';
import PropTypes from 'prop-types';
import { 
  HomeIcon, 
  PackageIcon, 
  BroadcastIcon, 
  ContainerIcon, 
  OrganizationIcon 
} from '@primer/octicons-react';
import NavigationMenu from './NavigationMenu';

/**
 * Composant du menu housing
 * Affiche les options housing selon le type d'utilisateur
 * 
 * @param {Object} props - Props du composant
 * @param {Object} props.me - Utilisateur connecté
 * @param {string} props.menuOpened - Clé du menu actuellement ouvert
 * @param {Function} props.getIconTag - Fonction pour obtenir les icônes
 * @param {Function} props.handleMenu - Handler pour les clics sur le menu
 * @param {Function} props.t - Fonction de traduction
 * @returns {JSX.Element} Composant NavigationHousing
 */
const NavigationHousing = ({ me, menuOpened, getIconTag, handleMenu, t }) => {
  if (!me) {
    return null;
  }

  // Menu avec options déroulantes pour les super admins (type < 20)
  if (me.type < 20) {
    const housingOptions = [
      { icon: getIconTag(PackageIcon), label: t("navigation.housings.device"), link: "/devices" },
      { icon: getIconTag(BroadcastIcon), label: t("navigation.housings.box"), link: "/boxes" },
      { icon: getIconTag(HomeIcon), label: t("navigation.housings.housing"), link: "/housings" },
      { icon: getIconTag(ContainerIcon), label: t("navigation.housings.housinggroup"), link: "/housinggroups" },
      { icon: getIconTag(OrganizationIcon), label: t("navigation.housings.jointhousinggroup"), link: "/jointhousinggroups" }
    ];

    return (
      <NavigationMenu
        menuKey="housing"
        menuOpened={menuOpened}
        title={{ icon: getIconTag(HomeIcon), label: t("navigation.housings.label") }}
        options={housingOptions}
        handleMenu={handleMenu}
      />
    );
  }

  // Lien simple pour type 20-39
  if (me.type >= 20 && me.type < 40) {
    return (
      <NavigationMenu
        menuKey="housing"
        menuOpened={menuOpened}
        title={{ icon: getIconTag(HomeIcon), label: t("navigation.housings.label") }}
        link="/jointhousinggroups"
        handleMenu={handleMenu}
      />
    );
  }

  // Lien simple pour type 40+
  if (me.type >= 40) {
    return (
      <NavigationMenu
        menuKey="housing"
        menuOpened={menuOpened}
        title={{ icon: getIconTag(HomeIcon), label: t("navigation.housings.label") }}
        link="/housings"
        handleMenu={handleMenu}
      />
    );
  }

  return null;
};

NavigationHousing.propTypes = {
  me: PropTypes.object,
  menuOpened: PropTypes.string,
  getIconTag: PropTypes.func.isRequired,
  handleMenu: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default NavigationHousing;
